import { Fade, Icon, ButtonBase, TextField, Grid, Button, Tabs, Tab, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import CustomMaskedOutput from 'components/MaskedOutput/index';
import MyTable, { MyTableBody, MyTableHeader, MyTableRow, MyTableCol, MyTablePagination } from 'components/MyTable/';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import { constants } from 'helpers';
import moment from 'moment';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  listProductsChildren,
  listCoupons,
  loadProduct,
  excludeCoupon,
  listCoProducers,
  listCouponsBatch,
  exportCouponsBatch,
  inactivateBatch,
} from 'store/Orbita/Product/actions';
import 'moment/locale/pt-br';

import CouponBatchForm from './components/CouponBatchForm/index';
import CouponForm from './components/CouponForm/index';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  match: any;
  children: any;
  coupons: any;
  couponsBatch: any;
  product: any;
  pagination: any;
  paginationBatch: any;
  exportBatch: any;
  user: any;
}

interface IStates {
  isFetching: boolean;
  idProduct: any;
  isVariation: boolean;
  isProduct: boolean;
  isFetchingProduct: boolean;
  tabSelected: number;
  status: string;
  anchorEl: any;
  excludingId: any;
  openCouponForm: boolean;
  openCouponBatchForm: boolean;
  coupomBatch: string;
  batchStatusFilter: string;
  fetchMessage: string;
}

class Coupons extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isFetching: true,
      idProduct: 0,
      isVariation: false,
      isProduct: false,
      isFetchingProduct: true,
      tabSelected: 0,
      status: 'active',
      anchorEl: null,
      excludingId: null,
      openCouponForm: false,
      openCouponBatchForm: false,
      coupomBatch: '',
      batchStatusFilter: 'active',
      fetchMessage: 'Carregando...',
    };
  }

  componentDidMount() {
    const params = this.props.match.params;
    if (params.productId && params.variationId) {
      (async () => {
        this.setState({ isFetching: true, isVariation: true, fetchMessage: 'Carregando...' });
        await this.props.dispatch(listCoupons(params.variationId, { per_page: 10, page: 1 }, this.state.status));
        this.setState({ isFetching: false });
      })();
      (async () => {
        try {
          this.setState({ isFetchingProduct: true, fetchMessage: 'Carregando...' });
          await Promise.all([
            this.props.dispatch(loadProduct(params.variationId)),
            this.props.dispatch(listProductsChildren(params.productId)),
            this.props.dispatch(listCoProducers(params.productId)),
          ]);
          this.setState({ isFetchingProduct: false, idProduct: params.variationId });
        } catch {
          toast.error('Ops, erro na listagem de variações');
        }
      })();
    } else {
      (async () => {
        this.setState({ isFetching: true, isProduct: true, fetchMessage: 'Carregando...' });
        await this.props.dispatch(listCoupons(params.productId, { per_page: 10, page: 1 }, this.state.status));
        this.setState({ isFetching: false });
      })();
      (async () => {
        try {
          this.setState({ isFetchingProduct: true, fetchMessage: 'Carregando...' });
          await Promise.all([this.props.dispatch(loadProduct(params.productId)), this.props.dispatch(listCoProducers(params.productId))]);
          this.setState({ isFetchingProduct: false, idProduct: params.productId });
        } catch {
          toast.error('Ops, erro ao carregar produto');
        }
      })();
    }
  }

  handleCloseCouponForm = () => {
    this.setState({ openCouponForm: false });
  };

  handleCouponBatchForm = () => {
    this.setState({ openCouponBatchForm: !this.state.openCouponBatchForm });
  };

  handleOpenCouponForm = () => {
    this.setState({ openCouponForm: true });
  };

  onChangePaginationNumber = (page: any) => {
    this.onShowSizeChange(page, this.props.pagination.per_page);
  };

  onShowSizeChange = (current: any, size: any) => {
    if (this.state.status === 'batchActive' || this.state.status === 'batchInactive') {
      (async () => {
        this.setState({ isFetching: true, fetchMessage: 'Carregando...' });
        await this.props.dispatch(listCouponsBatch(this.state.idProduct, { per_page: size, page: current }, this.state.batchStatusFilter));
        this.setState({ isFetching: false });
      })();
    } else {
      (async () => {
        this.setState({ isFetching: true, fetchMessage: 'Carregando...' });
        await this.props.dispatch(listCoupons(this.state.idProduct, { per_page: size, page: current }, this.state.status));
        this.setState({ isFetching: false });
      })();
    }
  };

  handleChangeTab = (event: any, value: any) => {
    let status = this.state.status;

    if (value === 0) {
      status = 'active';
    }
    if (value === 1) {
      status = 'inactive';
    }
    if (value === 2) {
      status = 'batchActive';
      this.setState({ batchStatusFilter: 'active' });
    }
    if (value === 3) {
      status = 'batchInactive';
      this.setState({ batchStatusFilter: 'inactive' });
    }

    this.setState({ tabSelected: value, status }, () => this.onShowSizeChange(1, this.props.pagination.per_page));
  };

  handleChangeProduct = (e: any) => {
    this.setState({ idProduct: e.target.value }, async () => {
      this.onShowSizeChange(1, this.props.pagination.per_page);
      this.setState({ isFetchingProduct: true, fetchMessage: 'Carregando...' });
      await this.props.dispatch(loadProduct(this.state.idProduct));
      this.setState({ isFetchingProduct: false });
    });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuOpen = (event: any) => {
    this.setState({ anchorEl: event.currentTarget, excludingId: event.target.getAttribute('data-coupon') });
  };

  handleBatchMenuOpen = (event: any, batch: string) => {
    this.setState({
      anchorEl: event.currentTarget,
      excludingId: event.target.getAttribute('data-coupon'),
      coupomBatch: batch,
    });
  };

  handleExcludeClick = () => {
    (async () => {
      try {
        this.setState({ isFetching: true, fetchMessage: 'Arquivando...' });
        await this.props.dispatch(excludeCoupon(this.state.idProduct, this.state.excludingId));
        this.setState({ isFetching: false });
        this.onShowSizeChange(this.props.pagination.page, this.props.pagination.per_page);
        toast.success('Cupom arquivado com sucesso!');
        this.setState({ anchorEl: null });
      } catch (error) {
        toast.error('Erro ao arquivar cupom');
        this.setState({ anchorEl: null });
      }
    })();
  };

  handleExportCsv = async () => {
    this.setState({ isFetching: true, fetchMessage: 'Exportando...' });
    await this.props.dispatch(exportCouponsBatch(this.state.idProduct, this.state.coupomBatch));
    this.setState({ isFetching: false, anchorEl: null });
  };

  handleBatchInactivity = async () => {
    this.setState({ isFetching: true, fetchMessage: 'Exportando...' });
    await this.props.dispatch(inactivateBatch(this.state.idProduct, this.state.coupomBatch));
    this.setState({ isFetching: false, anchorEl: null });
    this.handleChangeTab('', 2);
    toast.success('Lote arquivado com sucesso.');
  };

  render() {
    const spinner = <Spin message={this.state.fetchMessage} />;

    const indexes = [
      { title: 'Chave', ordering: false },
      { title: 'Descrição', ordering: false },
      { title: 'Tipo', ordering: false },
      { title: 'Valor', ordering: false },
      { title: 'Limite de uso', ordering: false },
      { title: 'Validade', ordering: false },
      { title: 'URL', ordering: false },
      { title: '', ordering: false },
    ];

    const indexesCouponsBatch = [
      { title: 'Descrição', ordering: false },
      { title: 'Tipo', ordering: false },
      { title: 'Valor', ordering: false },
      { title: 'Limite de uso', ordering: false },
      { title: 'Validade', ordering: false },
      { title: '', ordering: false },
    ];

    const { children, product, user } = this.props;

    const alertStyles = {
      fontWeight: 400,
      marginTop: 10,
      fontSize: 14,
      lineHeight: '14px',
      color: '#f64756',
    };

    return (
      <Fade in={true} timeout={500}>
        <div>
          <div className='my-title' style={{ display: 'table' }}>
            <h1 style={{ width: '100%' }}>Cupons de desconto</h1>
            <p style={{ width: '100%', margin: 0 }}>Visualizar e adicionar cupons de desconto.</p>
          </div>

          <div className='m32'></div>

          <div
            style={{
              padding: '20px',
              backgroundColor: 'white',
              borderRadius: '4px',
              boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
            }}
          >
            <MuiThemeProvider theme={theme}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    placeholder={
                      (children && children.isFetching) || (product && product.isFetching)
                        ? 'Carregando lista de produtos...'
                        : 'Selecione um produto'
                    }
                    select
                    InputProps={{ fullWidth: true, disableUnderline: true, style: { fontSize: 20, color: '#192542' } }}
                    SelectProps={{ autoWidth: true, displayEmpty: true, native: true }}
                    disabled={children && children.isFetching ? true : false}
                    value={this.state.idProduct}
                    onChange={this.handleChangeProduct}
                  >
                    {this.state.isVariation && !this.state.isFetchingProduct && children.data.length === 0 && (
                      <option key='0' value={0} disabled={true}>
                        Nenhum produto encontrado
                      </option>
                    )}
                    {this.state.isVariation &&
                      !this.state.isFetchingProduct &&
                      children.data.length > 0 &&
                      children.data.map((product: any) => <option key={product.id} value={product.id}>{`${product.title} (${product.id})`}</option>)}
                    {this.state.isProduct && !this.state.isFetchingProduct && product && product.id && (
                      <option key={product.id} value={product.id}>{`${product.title} (${product.id})`}</option>
                    )}
                    {this.state.isProduct && !this.state.isFetchingProduct && product && !product.id && (
                      <option key='0' value={0} disabled={true}>
                        Produto não encontrado
                      </option>
                    )}
                    {this.state.isFetchingProduct && (
                      <option key='0' value={this.state.idProduct} disabled={true}>
                        Carregando produto(s)...
                      </option>
                    )}
                  </TextField>
                </Grid>
                <Grid xs={12} md={4}>
                  {!this.state.isFetchingProduct && product && product.charge_type === 'A' && product.membership_fee === false && (
                    <div style={alertStyles}>Cupons criados serão aplicados em TODAS as cobranças da assinatura</div>
                  )}
                  {!this.state.isFetchingProduct && product && product.charge_type === 'A' && product.membership_fee === true && (
                    <div style={alertStyles}>
                      Esse produto possui adesão na recorrência, então os cupons criados serão aplicados SOMENTE na adesão!
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} md={2}>
                  {user.coupom_batch && (
                    <Tooltip
                      disableFocusListener={!(product && product.type === constants.PHYSICAL && product.charge_type === 'A')}
                      disableHoverListener={!(product && product.type === constants.PHYSICAL && product.charge_type === 'A')}
                      disableTouchListener={!(product && product.type === constants.PHYSICAL && product.charge_type === 'A')}
                      title={
                        product.type === constants.PHYSICAL && product.charge_type === 'A'
                          ? 'Não é possível criar cupons de desconto em produtos físicos de recorrência'
                          : ''
                      }
                      placement='bottom'
                    >
                      <div>
                        <Button
                          onClick={this.handleCouponBatchForm}
                          disabled={
                            this.state.isFetching ||
                            this.state.isFetchingProduct ||
                            (this.state.isVariation && !this.state.isFetchingProduct && children.data.length === 0) ||
                            (this.state.isProduct && !this.state.isFetchingProduct && product && !product.id) ||
                            (!this.state.isFetchingProduct && product && product.charge_type === 'A' && product.membership_fee === false) ||
                            (product && product.charge_type === 'A' && product.type === constants.PHYSICAL) ||
                            product.charge_type === 'L'
                          }
                          variant='contained'
                          fullWidth
                          color='secondary'
                        >
                          Cupom em lote
                        </Button>
                      </div>
                    </Tooltip>
                  )}
                </Grid>
                <Grid item xs={12} md={2}>
                  <Tooltip
                    disableFocusListener={!(product && product.type === constants.PHYSICAL && product.charge_type === 'A')}
                    disableHoverListener={!(product && product.type === constants.PHYSICAL && product.charge_type === 'A')}
                    disableTouchListener={!(product && product.type === constants.PHYSICAL && product.charge_type === 'A')}
                    title={
                      product.type === constants.PHYSICAL && product.charge_type === 'A'
                        ? 'Não é possível criar cupons de desconto em produtos físicos de recorrência'
                        : ''
                    }
                    placement='bottom'
                  >
                    <div>
                      <Button
                        onClick={this.handleOpenCouponForm}
                        disabled={
                          this.state.isFetching ||
                          this.state.isFetchingProduct ||
                          (this.state.isVariation && !this.state.isFetchingProduct && children.data.length === 0) ||
                          (this.state.isProduct && !this.state.isFetchingProduct && product && !product.id) ||
                          (product && product.charge_type === 'A' && product.type === constants.PHYSICAL) ||
                          (product && product.charge_type === 'L')
                        }
                        variant='contained'
                        fullWidth
                        color='secondary'
                      >
                        Criar cupom
                      </Button>
                    </div>
                  </Tooltip>
                </Grid>
              </Grid>
              {product.type === constants.PHYSICAL && (
                <Grid container alignItems='center'>
                  <Grid item xs={12}>
                    <p style={{ width: '100%', margin: 0 }}>* O cupom de desconto só será aplicado no item do produto e não no frete.</p>
                  </Grid>
                </Grid>
              )}
              {!user.coupom_batch ? (
                <Tabs value={this.state.tabSelected} onChange={this.handleChangeTab} indicatorColor='primary' textColor='primary' scrollButtons='off'>
                  <Tab label='Ativos' />
                  <Tab label='Arquivados' />
                </Tabs>
              ) : (
                <Tabs value={this.state.tabSelected} onChange={this.handleChangeTab} indicatorColor='primary' textColor='primary' scrollButtons='off'>
                  <Tab label='Ativos' />
                  <Tab label='Arquivados' />
                  <Tab label='Cupons em lote' />
                  <Tab label='lotes arquivados' />
                </Tabs>
              )}
              {user.coupom_batch && this.state.isFetching && this.state.tabSelected === 3
                ? spinner
                : this.state.tabSelected === 3 && (
                    <Fragment>
                      <MyTable>
                        <MyTableHeader index={indexesCouponsBatch} />
                        <MyTableBody>
                          {this.props.couponsBatch &&
                            Array.isArray(this.props.couponsBatch) &&
                            this.props.couponsBatch.map((coupon: any) => (
                              <MyTableRow key={coupon.description}>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={1}>
                                  {coupon.description}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={2}>
                                  {coupon.type}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={3}>
                                  <CustomMaskedOutput mask='money' value={coupon.value} />
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={4}>
                                  {coupon.quantity && parseInt(coupon.quantity) > 0 ? coupon.quantity : 'Ilimitado'}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={4}>
                                  {coupon.limeted_date
                                    ? moment(coupon.limeted_date).format('L') + ' ' + moment(coupon.limeted_date).format('HH:mm')
                                    : 'Sem validade'}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 1, sm: 1, md: 12, lg: 1 }} mobileOrder={7}></MyTableCol>
                              </MyTableRow>
                            ))}
                        </MyTableBody>
                      </MyTable>
                      <MyTablePagination
                        onPageChange={(e: any, page: any) => this.onChangePaginationNumber(page + 1)}
                        rowsPerPage={this.props.paginationBatch ? this.props.paginationBatch.per_page : 0}
                        count={this.props.paginationBatch ? this.props.paginationBatch.total_items : 0}
                        page={this.props.paginationBatch ? this.props.paginationBatch.current_page - 1 : 0}
                        labelDisplayedRows={({ from, to, count }: any) => `${from}-${to} de ${count}`}
                        labelRowsPerPage='Itens por página:'
                        onChangeRowsPerPage={(e: any) => this.onShowSizeChange(1, e.target.value)}
                        rowsPerPageOptions={[10, 20, 30, 40]}
                      />
                    </Fragment>
                  )}
              {user.coupom_batch && this.state.isFetching && this.state.tabSelected === 2
                ? spinner
                : this.state.tabSelected === 2 && (
                    <Fragment>
                      <MyTable>
                        <MyTableHeader index={indexesCouponsBatch} />
                        <MyTableBody>
                          {this.props.couponsBatch &&
                            Array.isArray(this.props.couponsBatch) &&
                            this.props.couponsBatch.map((coupon: any) => (
                              <MyTableRow key={coupon.description}>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={1}>
                                  {coupon.description}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={2}>
                                  {coupon.type}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={3}>
                                  <CustomMaskedOutput mask='money' value={coupon.value} />
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={4}>
                                  {coupon.quantity && parseInt(coupon.quantity) > 0 ? coupon.quantity : 'Ilimitado'}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 1, lg: 3 }} mobileOrder={4}>
                                  {coupon.limeted_date
                                    ? moment(coupon.limeted_date).format('L') + ' ' + moment(coupon.limeted_date).format('HH:mm')
                                    : 'Sem validade'}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 1, sm: 1, md: 12, lg: 1 }} mobileOrder={7}>
                                  <ButtonBase data-coupon={1} onClick={(e: any) => this.handleBatchMenuOpen(e, coupon.batch)}>
                                    <Icon data-coupon={1}>more_horiz</Icon>
                                  </ButtonBase>
                                </MyTableCol>
                              </MyTableRow>
                            ))}
                        </MyTableBody>
                      </MyTable>
                      <MyTablePagination
                        onPageChange={(e: any, page: any) => this.onChangePaginationNumber(page + 1)}
                        rowsPerPage={this.props.paginationBatch ? this.props.paginationBatch.per_page : 0}
                        count={this.props.paginationBatch ? this.props.paginationBatch.total_items : 0}
                        page={this.props.paginationBatch ? this.props.paginationBatch.current_page - 1 : 0}
                        labelDisplayedRows={({ from, to, count }: any) => `${from}-${to} de ${count}`}
                        labelRowsPerPage='Itens por página:'
                        onChangeRowsPerPage={(e: any) => this.onShowSizeChange(1, e.target.value)}
                        rowsPerPageOptions={[10, 20, 30, 40]}
                      />
                      {!this.state.isFetching && (
                        <Menu id='simple-menu' anchorEl={this.state.anchorEl} open={Boolean(this.state.anchorEl)} onClose={this.handleCloseMenu}>
                          <MenuItem onClick={this.handleBatchInactivity}>Arquivar Lote</MenuItem>
                          <MenuItem onClick={this.handleExportCsv}>Exportar</MenuItem>
                        </Menu>
                      )}
                    </Fragment>
                  )}
              {this.state.isFetching && this.state.tabSelected !== 2 && this.state.tabSelected !== 3
                ? spinner
                : this.state.tabSelected !== 2 &&
                  this.state.tabSelected !== 3 && (
                    <Fragment>
                      <MyTable>
                        <MyTableHeader index={indexes} />
                        <MyTableBody>
                          {this.props.coupons &&
                            this.props.coupons.map((coupon: any) => (
                              <MyTableRow key={`coupon-${coupon.id}`}>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }} mobileOrder={1}>
                                  {coupon.key}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }} mobileOrder={2}>
                                  {coupon.description}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }} mobileOrder={3}>
                                  {coupon.type === 'P' ? 'Percentual' : 'Valor'}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }} mobileOrder={4}>
                                  <CustomMaskedOutput mask='money' value={coupon.value} />
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }} mobileOrder={5}>
                                  {coupon.quantity && parseInt(coupon.quantity) > 0 ? coupon.quantity : 'Ilimitado'}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }} mobileOrder={6}>
                                  {coupon.limeted_date === false
                                    ? 'Sem validade'
                                    : moment(coupon.limeted_date).format('L') + ' ' + moment(coupon.limeted_date).format('HH:mm')}
                                </MyTableCol>
                                <MyTableCol screenSizes={{ xs: 10, sm: 1, md: 6, lg: 3 }} mobileOrder={7}>
                                  <CustomCopyToClipboard
                                    text={`https://sun.eduzz.com/${this.state.idProduct}?cupom=${coupon.key}`}
                                    disableUnderline
                                  />
                                </MyTableCol>
                                <MyTableCol numeric screenSizes={{ xs: 2, sm: 1, md: 6, lg: 3 }} mobileOrder={8}>
                                  {this.state.tabSelected !== 1 && (
                                    <ButtonBase data-coupon={coupon.id} onClick={this.handleMenuOpen}>
                                      <Icon data-coupon={coupon.id}>more_horiz</Icon>
                                    </ButtonBase>
                                  )}
                                </MyTableCol>
                              </MyTableRow>
                            ))}
                        </MyTableBody>
                      </MyTable>
                      <MyTablePagination
                        onPageChange={(e: any, page: any) => this.onChangePaginationNumber(page + 1)}
                        rowsPerPage={this.props.pagination ? this.props.pagination.per_page : 0}
                        count={this.props.pagination ? this.props.pagination.total_items : 0}
                        page={this.props.pagination ? this.props.pagination.current_page - 1 : 0}
                        labelDisplayedRows={({ from, to, count }: any) => `${from}-${to} de ${count}`}
                        labelRowsPerPage='Itens por página:'
                        onChangeRowsPerPage={(e: any) => this.onShowSizeChange(1, e.target.value)}
                        rowsPerPageOptions={[10, 20, 30, 40]}
                      />
                      {!this.state.isFetching && (
                        <Menu id='simple-menu' anchorEl={this.state.anchorEl} open={Boolean(this.state.anchorEl)} onClose={this.handleCloseMenu}>
                          <MenuItem onClick={this.handleExcludeClick}>Arquivar</MenuItem>
                        </Menu>
                      )}
                    </Fragment>
                  )}
            </MuiThemeProvider>
          </div>
          {this.state.openCouponForm && (
            <CouponForm
              update={this.handleChangeTab}
              open={this.state.openCouponForm}
              handleClose={this.handleCloseCouponForm}
              product={this.state.idProduct}
            />
          )}
          {this.state.openCouponBatchForm && (
            <CouponBatchForm
              update={this.handleChangeTab}
              open={this.state.openCouponBatchForm}
              handleClose={this.handleCouponBatchForm}
              product={this.state.idProduct}
            />
          )}
        </div>
      </Fade>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    children: state.orbita.Product.listProductsChildren,
    coupons: state.orbita.Product.listCoupons.data,
    couponsBatch: state.orbita.Product.listCouponsBatch.data,
    paginationBatch: state.orbita.Product.listCouponsBatch.pagination,
    pagination: state.orbita.Product.listCoupons.pagination,
    exportBatch: state.orbita.Product.exportCouponsBatch,
    product: state.orbita.Product.product,
    user: state.orbita.User.user,
  };
}

export default connect(mapStateToProps)(Coupons);
